<form role="form" [formGroup]="classForm">
  <h1 mat-dialog-title>{{data.title}}</h1>
    <div style="display:flex;justify-content:space-evenly;">
      <div mat-dialog-content style="padding:5px;">
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Class Name</mat-label>
            <input matInput formControlName="classname" placeholder="Enter the name of the class">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="fill">
            <mat-label>Select Level</mat-label>
            <mat-select formControlName="Level_SysRef">
              <mat-option *ngFor="let level of (dataLevelList$ | async)" [value]="level.sysRef">
                {{level.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
        <p>
          <!--<mat-form-field appearance="fill">
          <mat-label>Select Subject</mat-label>
          <mat-select formControlName="Subject_SysRef">
              <mat-option *ngFor="let subject of (dataSubjectList$ | async)" [value]="subject.sysRef">
                  {{subject.name}}
              </mat-option>
          </mat-select>
      </mat-form-field>-->
        </p>
        <p>
          <mat-form-field appearance="fill">
            <mat-label>Select Supervisor</mat-label>
            <mat-select formControlName="Supervisor_SysRef">
              <mat-option *ngFor="let supervisor of (dataSupervisorList$ | async)" [value]="supervisor.sysRef">
                {{supervisor.firstName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </p>
        <!--<p>
        <mat-form-field appearance="fill">
            <mat-label>Select ClassSet</mat-label>
            <mat-select formControlName="ClassSet_SysRef">
                <mat-option *ngFor="let classset of (dataClassSetList$ | async)" [value]="classset.sysRef">
                    {{classset.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        </p>-->
      </div>
      <div style="display: flex; background-color: #DEDEDE; padding:5px;">
        <div class="answersDialog">
          <span style="padding:5px"> Subjects</span>
          <div formArrayName="subjects">
            <div style="display:flex">
              <span style="padding:10px">(Add a minimum of one subject)</span>
              <div style="flex-grow: 5; text-align: right;padding:3px">
                <button type="button" mat-button (click)="addSubject()">Add</button>
              </div>
            </div>
            <div style="display:flex;" *ngFor="let m of subjects().controls; let i=index" [formGroupName]="i">
              <mat-form-field appearance="fill">
                <mat-label>Select Subject</mat-label>
                <mat-select formControlName="SysRef">
                  <mat-option *ngFor="let subject of (dataSubjectList$ | async)" [value]="subject.sysRef">
                    {{subject.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">Close</button>
        <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="addClass()">Save</button>
    </div>
</form>
